import React from "react";
import PropTypes from "prop-types";
import { withNamespaces, Trans } from "react-i18next";
import Link from "ati-ui-react/components/Link";

import styles from "./RouteWithoutRestrictions.scss";
import { SUPPORT_EMAIL } from "../../constants";

const RouteWithoutRestrictions = ({ containerRef }) => (
  <div className={styles.alert} ref={containerRef}>
    <span className={styles.message}>
      <Trans i18nKey="trace-route-found-without-restrictions">Нет маршрутов, которые полностью подходят. Но есть варианты с отклонениями от заданных параметров.</Trans>
    </span>
    <div className={styles.report}>
      <Link
        type="pseudo"
        small
        href={`mailto:${SUPPORT_EMAIL}`}
        gray
      >
        <Trans i18nKey="trace-route-not-found-report-error">Сообщить об ошибке</Trans>
      </Link>
    </div>
  </div>
);

RouteWithoutRestrictions.defaultProps = {
  containerRef: undefined,
};

RouteWithoutRestrictions.propTypes = {
  containerRef: PropTypes.func,
};

export default withNamespaces()(RouteWithoutRestrictions);
